import { IsArray, IsBoolean, IsNotEmpty, IsNumber, IsOptional, IsString, Length } from 'class-validator';
import { MembershipTypeDto } from './membershipType.dto';
import { Exclude } from 'class-transformer';

/**
 * DTO object for patching of Brand Membership Type.
 */
export class MembershipTypeUpdateDto extends MembershipTypeDto {
  @Exclude()
  brandId: number;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @Length(0, 150)
  name: string;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @Length(0, 255)
  photoUrl: string;

  @IsOptional()
  @IsString()
  @IsNotEmpty()
  @Length(0, 255)
  description: string;

  @IsOptional()
  @IsBoolean()
  active: boolean;

  @IsOptional()
  @IsNumber()
  discountTypeId: number;

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  merchants: number[];
}
